"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadEL = void 0;
const _1 = require(".");
const controls_1 = require("./controls");
const loadEL = (rawLaw) => {
    if (typeof rawLaw === "string") {
        return rawLaw;
    }
    else {
        if (!rawLaw.children) {
            console.error("[load_el]", rawLaw);
        }
        const attr = { ...rawLaw.attr };
        let id = undefined;
        let range = undefined;
        if ("__id" in rawLaw.attr) {
            id = JSON.parse(rawLaw.attr["__id"] ?? "");
            delete attr["__id"];
        }
        if ("__range" in rawLaw.attr) {
            range = JSON.parse(rawLaw.attr["__range"] ?? "");
            delete attr["__range"];
        }
        const _el = new _1.EL(rawLaw.tag, attr, rawLaw.children.map(exports.loadEL), range, id);
        const el = _el.isControl ? (0, controls_1.controlFromEL)(_el) : _el;
        return el;
    }
};
exports.loadEL = loadEL;
exports.default = exports.loadEL;
//# sourceMappingURL=loadEL.js.map